// extracted by mini-css-extract-plugin
export var content = "_mw-1";
export var divider = "_mw-0";